export default () => ({
  showDrawer: false,
});
